// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//


import { filterStyles } from "@bg/Overrides/Widgets/MyLists/MyListsFilter";
import { css } from "styled-components";

filterStyles.container = {
    gap: 20,
    css: css`
        margin-top: 8px;
    `,
};

filterStyles.fromGridItem = {
    width: [6, 6, 3, 3, 2],
    css: css`
        > div {
            width: 100% !important;
        }
    `,
};

filterStyles.toGridItem = {
    width: [6, 6, 3, 3, 2],
    css: css`
        > div {
            width: 100% !important;
        }
    `,
};

filterStyles.toDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
            margin-top: 26px;
        `,
    },
};

filterStyles.filtersContainer = {
    css: css`
        padding: 10px 10px 15px;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    `,
};

filterStyles.autocompleteGridItem = {
    width: [12, 12, 3, 3, 4],
    css: css`
        padding: 0;
    `,
};